var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.59,
    height: 7.59,
    viewBox: "0 0 7.59 7.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#231f20;stroke-miterlimit:10;}.cls-1{stroke-width:0.5px;}.cls-2{stroke-linecap:round;stroke-width:0.65px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.8,
    cy: 3.8,
    r: 3.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.8,5.19s-1-1.46-.93-1.39H5.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.8,2.4s-1,1.46-.93,1.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.3e5aedca5cbfbcb1905af308f8eb991e.svg";
export { ForwardRef as ReactComponent };